<div *ngIf="!financialInstitution" class="flex flex-col" [@openClose]>
	<div [@openClose] *ngIf="mortgageeType === mortgageeTypes.INSTITUTION">
		<div>Select a leading bank</div>
		<div class="flex gap-3 py-5 flex-wrap">
			<ng-container *ngFor="let bank of lenders">
				<div
					class="p-2 cursor-pointer hover:shadow-md flex items-center justify-center w-24"
					(click)="setLeadingBank(bank.institutionId)"
				>
					<img [src]="'/assets/images/banks/' + bank.logo" />
				</div>
			</ng-container>
		</div>
		<span class="pb-5">Or search here</span>
	</div>
	<span class="pb-2" *ngIf="mortgageeType === mortgageeTypes.OTHER"
		>Search here</span
	>

	<app-institution-search
		(onSelected)="onInstitutionSelect($event)"
		[mortgageeType]="mortgageeType"
		[fileType]="fileType"
		[showDischargeFields]="showDischargeFields"
		[pushChangesToGlobalData]="pushChangesToGlobalData"
	>
	</app-institution-search>
</div>

<div *ngIf="financialInstitution" class="border rounded-md border-grey-light">
	<!-- Institution Heading -->
	<div class="bg-grey-veryLight p-5 pb-4 rounded-t-md">
		<div class="flex justify-between">
			<div class="flex items-center">
				<app-icon
					*ngIf="!financialInstitution?.logoUrl"
					[icon]="ICON.MORTGAGE"
					class="text-2xl text-grey"
				></app-icon>
				<img
					*ngIf="financialInstitution?.logoUrl"
					class="max-h-10 institution-logo"
					[src]="'/assets/images/banks/' + financialInstitution?.logoUrl"
				/>

				<div class="flex flex-col justify-items-start ml-5">
					<h6 class="text-lg break-words font-bold">
						{{ financialInstitution?.name }}
					</h6>
				</div>
			</div>
			<atomic-kebab-options
				*ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE"
				[itemGroups]="[{ items: institutionDropDownItems }]"
				(onSelect)="dropdownOptionSelect($event)"
			>
			</atomic-kebab-options>
		</div>
		<div
			class="mt-2"
			*ngIf="
				financialInstitution?.address &&
				mortgageeType !== mortgageeTypes.COMPUTERSHARE
			"
		>
			<app-icon [icon]="ICON.LOCATION" class="text-grey-light mr-3"></app-icon>
			<span class="text-sm">{{ financialInstitution?.address | address }}</span>
		</div>
	</div>

	<!-- When institution is not Computershare -->
	<div class="px-5 py-3" *ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE">
		<div class="mb-3">
			<div class="flex mb-1 font-bold">
				<span *ngIf="!showDischargeFields">Arranged contact</span>
				<span *ngIf="showDischargeFields">Request Payout Statement</span>
			</div>

			<app-payout-message
				*ngIf="showDischargeFields"
				[institution]="financialInstitution"
			></app-payout-message>
		</div>
		<ng-container *ngIf="institutionContactDetails">
			<app-contact-details-card
				*ngIf="!financialInstitution?.discharge?.requestMethod"
				(edit)="updateInstitution()"
				[contactDetails]="institutionContactDetails"
				[isEditable]="allowInstEdit"
				contactType="lender"
			>
			</app-contact-details-card>
			<ui-section
				*ngIf="showInstitutionPrimary"
				title="Follow Up"
				size="small"
				class="flex-col mt-2 container--dark"
				[collapsable]="true"
				[collapsed]="true"
			>
				<app-contact-details-card
					section-content
					(edit)="updateInstitution()"
					[contactDetails]="institutionContactDetails"
					contactType="lender"
				>
				</app-contact-details-card>
			</ui-section>
			<ui-section
				*ngIf="showInstitutionEscalation"
				title="Escalation"
				size="small"
				class="flex-col mt-2 container--dark"
				[ngClass]="showInstitutionPrimary ? 'mt-6' : 'mt-2'"
				[collapsable]="true"
				[collapsed]="true"
			>
				<app-contact-details-card
					section-content
					(edit)="updateInstitution()"
					[contactDetails]="escalationContactDetails"
					contactType="lender"
				>
				</app-contact-details-card>
			</ui-section>
		</ng-container>

		<div class="mt-2 pt-2 border-t border-grey-veryLight" [@openClose]>
			<div class="flex items-center w-full">
				<span class="font-bold mr-4" *ngIf="financialInstitution?.branch"
					>Branch</span
				>
				<div
					class="flex items-center w-full"
					*ngIf="!financialInstitution?.branch"
				>
					<span class="font-bold mr-4" *ngIf="!showDischargeFields"
						>Branch</span
					>
					<app-financial-institution-branch-search
						class="w-full"
						[financialInstitution]="financialInstitution"
						[fileType]="fileType"
						(onSelectedBranch)="onSelectedBranch($event)"
						[showDischargeFields]="showDischargeFields"
						[autoComplete]="showAddBranch"
						(toggleAddBranch)="toggleAddBranch()"
					>
					</app-financial-institution-branch-search>
				</div>
				<app-button
					*ngIf="financialInstitution?.branch"
					size="small"
					btn="border"
					[icon]="ICON.REFRESH"
					(click)="switchBranch()"
				>
					Switch branch
				</app-button>
			</div>
		</div>

		<div class="pt-4" *ngIf="financialInstitution?.branch">
			<app-container>
				<div class="flex flex-col">
					<div class="font-bold flex items-center justify-between">
						<span class="mr-5">
							<span>
								{{
									financialInstitution?.branch?.name
										? financialInstitution?.branch?.name
										: 'Branch'
								}}
							</span>
						</span>
						<atomic-kebab-options
							*ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE"
							[itemGroups]="[{ items: branchDropDownItems }]"
							(onSelect)="branchDropdownOptionSelect($event)"
						>
						</atomic-kebab-options>
					</div>
					<div class="text-sm mb-6">
						<span>{{ financialInstitution?.branch?.address | address }}</span>
					</div>
				</div>
				<app-contact-details-card
					(edit)="_editBranch()"
					[contactDetails]="branchContactDetails"
					contactType="branch"
				>
				</app-contact-details-card>
				<ui-section
					*ngIf="showBranchEscalation"
					title="Escalation"
					size="small"
					class="flex-col mt-6 container--dark"
					[collapsable]="true"
					[collapsed]="true"
				>
					<app-contact-details-card
						section-content
						(edit)="_editBranch()"
						[contactDetails]="branchEscalationContactDetails"
						contactType="branch"
					>
					</app-contact-details-card>
				</ui-section>
			</app-container>
		</div>
	</div>

	<!-- When institution is Computershare -->
	<ng-container *ngIf="mortgageeType === mortgageeTypes.COMPUTERSHARE">
		<!-- When branch has not been selected -->
		<div
			*ngIf="!financialInstitution?.branch"
			class="flex flex-col py-5 px-3"
			[@openClose]
		>
			<div [@openClose]>
				<div>Select a lender</div>
				<div class="flex gap-3 py-5 flex-wrap">
					<ng-container *ngFor="let lender of popularCSLenders">
						<div
							class="p-2 cursor-pointer hover:shadow-md flex items-center justify-center w-24"
							(click)="setLeadingCSLender(lender.institutionId)"
						>
							<img [src]="'/assets/images/banks/' + lender.logo" />
						</div>
					</ng-container>
				</div>
				<span class="pb-5">Or search here</span>
			</div>
			<app-financial-institution-branch-search
				[financialInstitution]="financialInstitution"
				[showDischargeFields]="showDischargeFields"
				[fileType]="fileType"
				[mortgageeType]="mortgageeType"
				[autoComplete]="true"
				(onSelectedBranch)="onSelectedBranch($event)"
			>
			</app-financial-institution-branch-search>
		</div>
		<!-- When branch has been selected  -->
		<div
			*ngIf="financialInstitution?.branch"
			class="flex flex-col px-5 py-3 gap-4"
			[@openClose]
		>
			<div class="flex items-center">
				<span class="font-bold mr-4">Lender</span>
				<app-button
					size="small"
					btn="border"
					[icon]="ICON.REFRESH"
					(click)="_removeBranch()"
				>
					Switch lender
				</app-button>
			</div>
			<app-container>
				<div class="mb-4">
					<div class="flex justify-between">
						<div class="flex items-center">
							<app-icon
								*ngIf="!financialInstitution?.branch.logoUrl"
								[icon]="ICON.MORTGAGE"
								class="text-2xl text-grey"
							></app-icon>
							<img
								*ngIf="financialInstitution?.branch.logoUrl"
								class="max-h-10"
								style="max-width: 85px"
								[src]="
									'/assets/images/banks/' + financialInstitution?.branch.logoUrl
								"
							/>

							<div class="flex flex-col justify-items-start ml-5">
								<h6 class="text-lg break-words font-bold">
									{{ financialInstitution?.branch.name }}
								</h6>
							</div>
						</div>
						<atomic-kebab-options
							[itemGroups]="[{ items: branchDropDownItems }]"
							(onSelect)="branchDropdownOptionSelect($event)"
						>
						</atomic-kebab-options>
					</div>
					<div class="mt-2" *ngIf="financialInstitution?.branch.address">
						<span class="text-sm">{{
							financialInstitution?.branch.address | address
						}}</span>
					</div>
				</div>
				<div class="flex mb-3">
					<p *ngIf="!showDischargeFields" class="font-bold">Arranged contact</p>
					<p *ngIf="showDischargeFields" class="font-bold">
						Payout/discharge contact
					</p>
				</div>

				<app-payout-message
					*ngIf="showDischargeFields"
					[institution]="financialInstitution"
					[branchId]="financialInstitution?.branch?.id"
				></app-payout-message>
				<ng-container *ngIf="showBranchPayoutDetails">
					<app-contact-details-card
						(edit)="_editBranch()"
						[contactDetails]="branchContactDetails"
						contactType="lender"
					>
					</app-contact-details-card>
					<app-container
						*ngIf="showBranchEscalation"
						title="Escalation"
						size="small"
						class="flex-col mt-6 container--dark"
						[collapsable]="true"
						[collapsed]="true"
					>
						<app-contact-details-card
							(edit)="_editBranch()"
							[contactDetails]="branchEscalationContactDetails"
							contactType="lender"
						>
						</app-contact-details-card>
					</app-container>
				</ng-container>
			</app-container>
		</div>
	</ng-container>
</div>
